import { Alert } from '@components/alert';
import { Button } from '@components/button';
import { CopyText } from '@components/copy-text-field';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { SocialShareButtons } from 'components/ShareJob/SocialShareButtons';
import { Tab, TabList, useTabState } from 'components/Tabs';
import { useAuthenticatedUser } from 'features/authentication';
import { Modal, ModalProps } from 'features/modals';
import { sharingSiteUrl } from 'features/routing';
import { Job } from 'types/jobs';
type ShareJobModalProps = ModalProps<{
  job: Job;
}>;

export const ShareJobFromCreateModal = (props: ShareJobModalProps) => {
  const { job, closeModal } = props;
  const { t } = useScopedTranslate(ShareJobLocale);

  const tabState = useTabState();
  const referral = tabState.selectedId === '1';
  const me = useAuthenticatedUser();
  const url = sharingSiteUrl(me, referral, job.id);

  if (!job) {
    return null;
  }

  return (
    <Modal>
      <Modal.Header text={t('header')} />
      <div>
        {/* @ts-expect-error */}
        <TabList state={tabState} label="Direct or Referral selection">
          <Tab>{t('direct')}</Tab>
          <Tab>{t('referral')}</Tab>
        </TabList>
        <Separator />
      </div>
      {referral && <Alert variant="info">{t('sharejobLabel')}</Alert>}
      {job && job.hasRewards && referral && (
        <Stack space={6}>
          <Text font="heading2" color="purple100" text={t('sharejobRewardsHeader')} />
          <div>
            <Text font="bold16" text={job.rewardsTitle} />
            <Text text={job.rewards} />
          </div>
        </Stack>
      )}
      <Stack space={1}>
        <CopyText
          copyText={t('copy')}
          copiedText={t('copied')}
          label={t(referral ? 'referral' : 'direct')}
          value={url}
        />
      </Stack>
      <Separator />
      <Text font="heading2" color="purple100" text={t('socialSharing')} />
      {/* @ts-expect-error */}
      <SocialShareButtons url={url} />
      <Modal.Actions>
        <Button variant="secondary" onClick={closeModal} text={t('close')} />
      </Modal.Actions>
    </Modal>
  );
};

const ShareJobLocale = {
  en: {
    header: 'Share job',
    direct: 'Direct link',
    referral: 'Referral link',
    sharejobLabel:
      'Applicants who apply through your personal referral link will be labeled as sourced by you.',
    sharejobRewardsHeader: 'Rewards for hired applicant',
    copy: 'Copy',
    copied: 'Copied',
    socialSharing: 'Social sharing',
    close: 'Close',
  },
  is: {
    header: 'Deila starfi',
    direct: 'Beinn hlekkur',
    referral: 'Tilvísunarhlekkur',
    sharejobLabel:
      'Umsækjendur sem sækja um í gegnum þína persónulegu tilvísunarslóð verða merktir í kerfinu sem sóttir af þér.',
    sharejobRewardsHeader: 'Verðlaun fyrir ráðinn umsækjanda',
    copy: 'Afrita',
    copied: 'Afritun tókst',
    socialSharing: 'Deila á samfélagsmiðlum',
    close: 'Loka',
  },
};
